var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tblOneComp"},[_c('div',{staticClass:"div_tbl"},[_c('table',{staticClass:"tbl_1"},_vm._l((_vm.rows),function(row,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(row.title))]),_c('td',[_vm._v(_vm._s(_vm.cellHandler(row.value, _vm.rows, row.type, row.handler)))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }